<template>
  <div class="info" :opened="opened">

    <div ref="icon" class="icon" @click="open">
      <img src="./../../assets/question.svg">
    </div>

    <div
        class="backdrop"
        @click="toggle($event)"
        ref="backdrop"
    ></div>

    <div class="cloud" ref="cloud">
      <img class="hic" ref="hic" src="./../../assets/hic.png">
    </div>

  </div>
</template>

<script>
export default {
  name: "StevilkaZdravstveneKarticeInfo",
  data: function () {
    return {
      opened: false
    }
  },
  methods: {
    open() {
      this.opened = true;
      let [moveX, moveY] = [0, 20];

      const cloudWidth = this.$refs.hic.clientWidth + 20;
      const cloudHeight = this.$refs.hic.clientHeight + 20;

      const cloudBCR = this.$refs.cloud.getBoundingClientRect();

      const cloudTop = cloudBCR.top;
      const cloudLeft = cloudBCR.left;

      const screenHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;

      // const screenWidth =
      //     window.innerWidth ||
      //     document.documentElement.clientWidth ||
      //     document.body.clientWidth;

      // position above
      if (cloudTop + cloudHeight + moveY > screenHeight) {
        moveY = -cloudHeight - 45;
      }

      const iconRight = this.$refs.icon.getBoundingClientRect().right;
      const cloudRight = cloudLeft + cloudWidth;

      const rightOffset = iconRight - cloudRight + 15;
      moveX += rightOffset;

      this.$refs.cloud.style.position = 'fixed';
      this.$refs.cloud.style.zIndex = 103;
      this.$refs.cloud.style.top = cloudBCR.top + 'px';
      this.$refs.cloud.style.left = cloudBCR.left + 'px';
      this.$refs.cloud.style.width = cloudWidth + 'px';
      this.$refs.cloud.style.height = cloudHeight + 'px';
      this.$refs.cloud.style.transform = `translateX(${moveX}px) translateY(${moveY}px)`;

      document.querySelector("body").style.overflow = "hidden";

      setTimeout(() => {
        this.toggleBackdrop(true);
      }, 300);
    },
    close() {
      this.opened = false;
      const cloud = this.$refs.cloud;

      this.toggleBackdrop(false);

      cloud.style.position = 'absolute';
      cloud.style.zIndex = 'unset';
      cloud.style.top = 'unset';
      cloud.style.left = 'unset';
      cloud.style.width = 'unset';
      cloud.style.height = 'unset';
      cloud.style.transform = "";
      document.querySelector("body").style.overflow = "hidden";

      setTimeout(() => {
        document.querySelector("body").style.overflow = "auto";
        cloud.style.zIndex = 0;
      }, 300);
    },
    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    toggleBackdrop(value) {
      this.$refs.backdrop.style.transform = `scaleY(${Number(value)})`;
      this.$refs.backdrop.style.opacity = Number(value);
    },
    toggle($event) {
      $event.stopPropagation();
      if (this.disabled) return;

      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    },
  }
}
</script>

<style scoped>

@media (min-width: 280px) {
  .icon {
    cursor: pointer;
  }

  .info {
    position: relative;
    margin-top: 14px;

    display: inline-block;
    margin-left: 16px;

    height: 18px;
    width: 18px;
  }

  .info .cloud {
    position: absolute;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    max-width: 0;
    max-height: 0;

    border-radius: 20px;
    box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.5);
  }

  .info .cloud .hic {
    max-width: 100vh;
    height: unset;
    display: inline-block;
    vertical-align: unset;

    opacity: 0;
    width: 260px;

    position: absolute;
    transform: scale(0);

    transition: all 0.3s ease-in-out;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome, Edge, Opera and Firefox */
  }

  .info[opened] .cloud {
    max-width: unset;
    max-height: unset;

    overflow: visible;
    padding: 10px;

    background-color: white;
  }

  .info[opened] .cloud .hic {
    opacity: 1;
    transform: scale(1);
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;

    height: 100vh;
    width: 100vw;
    z-index: 102;

    background-color: rgba(0, 0, 0, 0.5);

    transform-origin: center;
    transform: scaleY(0);
    opacity: 0;
    transition: opacity 0.1s linear;
  }
}

@media (min-width: 320px) {
  .info .cloud .hic {
    width: 300px;
  }
}

@media (min-width: 375px) {
  .info {
    margin-left: 16px;
  }

  .info .cloud .hic {
    width: 355px;
  }
}

@media (min-width: 1135px) {

  .info .cloud .hic {
    width: 300px;
  }

  .backdrop {
    opacity: 0 !important;
  }
}

</style>
